<template>
  <div class="c-announcement">
    <slot />
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.c-announcement {
  display: flex;
  flex-direction: column;
  height: 100%;
  max-width: 100%;
  overflow: hidden;
  position: relative;

  article {
    bottom: 0;
    box-sizing: border-box;
    color: $colour-nhs-core-white;
    padding: 10px;
    position: absolute;
    z-index: 20;
    &:before {
      background: linear-gradient(
        180deg,
        rgba(0, 0, 0, 0) 0%,
        rgba(0, 0, 0, 0.3) 100%
      );
      content: "";
      display: block;
      height: 100%;
      left: 0;
      position: absolute;
      top: 0;
      width: 100%;
      z-index: -1;
    }
  }

  img {
    position: absolute;
    width: 150%;
    z-index: 1;

    height: auto;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);

    @supports (object-fit: cover) {
      object-fit: cover;
      height: 100%;
    }
  }
}
</style>
